<template>
  <vs-wrapper>
    <vs-wrapper space="small">
      <vs-heading type="subhead">Create new batch</vs-heading>
      <vs-form ref="batchForm">
        <vs-text-input
          :value="newBatchNumber"
          autofocus
          label="Batch number"
          @input="
            (newSearch) => {
              newBatchNumber = newSearch
            }
          "
        />
      </vs-form>
      <v-tooltip bottom :disabled="newBatchNumber !== ''">
        <template v-slot:activator="{ on, attrs }">
          <div v-on="on" v-bind="attrs">
            <vs-button
              data-test="create-new-invoice-button"
              :label="`New batch ${newBatchNumber}`"
              full-width
              :disabled="newBatchNumber === ''"
              type="secondary"
              @click="save"
            />
          </div>
        </template>
        <span>Missing batch number</span>
      </v-tooltip>
    </vs-wrapper>
    <v-divider v-if="addDivider" aria-label="or" />
  </vs-wrapper>
</template>

<script setup lang="ts">
import moment from 'moment'
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useStore } from 'vuex-composition-helpers'
import { BatchPaymentTerms, PAYMENT_TERMS_OPTIONS } from '@/models/batch'
import { useCreateInvoiceMutation } from '@/api/invoice'
import { AxiosError } from 'axios'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsHeading from '@/components/vision/VsHeading.vue'
import VsForm from '@/components/vision/VsForm.vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import VsButton from '@/components/vision/VsButton.vue'
import { useFeatureFlagsQuery } from '@/api/composables/feature-flags'

const props = defineProps<{
  initialBatchNumberValue: string
  buttonLabel?: string
  addDivider?: boolean
}>()

const newBatchNumber = ref('')

interface FormData {
  batchNumber?: string | null
  batchDate?: moment.Moment | null
  paymentTerms?: BatchPaymentTerms | null
  dueDate?: moment.Moment | null
  memo?: string | null
}

const formData = reactive<FormData>({
  batchNumber: undefined,
  batchDate: undefined,
  paymentTerms: undefined,
  dueDate: undefined,
  memo: undefined,
})

watch(
  () => props.initialBatchNumberValue,
  (newVal) => {
    formData.batchNumber = newVal
  },
  { immediate: true },
)

onMounted(() => {
  formData.batchDate = moment()
})

const store = useStore()

const batchForm = ref()
const emit = defineEmits<{
  (e: 'empty-batch-number')
  (e: 'batch-draft-requested', data: { batchName: string })
}>()

async function save() {
  if (newBatchNumber.value === '') {
    emit('empty-batch-number')
    return
  }

  emit('batch-draft-requested', { batchName: newBatchNumber.value })
}
</script>
